import React from 'react';
import cn from 'clsx';
import { utpCardMedia, utpCardMediaContainer } from './utp-card-media-styles';

type UtpCardMediaProps = {
  alt: string;
  className?: string;
  src: string;
  title: string;
  wide?: boolean;
} & JSX.ReactHTMLImageElement;

export const UtpCardMedia: React.FC<UtpCardMediaProps> = ({ alt, className, src, title, ...rest }) => (
  <div className={utpCardMediaContainer}>
    <img alt={alt} className={cn(className, utpCardMedia)} src={src} title={title} {...rest} />
  </div>
);
